import React, { useCallback } from 'react';
import { useTheme } from '@mui/material/styles';
import { SnackbarProps } from 'modules/common/hooks/useSnackbarStyles';
import { useFeatureFlag } from 'modules/common/hooks';
import {
  NotesToastContext,
  useNotesToastContext
} from './NotesToastContextProvider';
import { NoteToast } from './NoteToast';

export type ShowSuccessToast = (showSuccess: boolean, message: string) => void;
export type ShowErrorToast = (showSuccess: boolean) => void;

export const NoteToasts: React.FC<SnackbarProps> = ({
  pinned = true
}: SnackbarProps) => {
  const {
    toastContext,
    setToastContext,
    dismiss,
    toastContextList,
    setToastContextList
  } = useNotesToastContext();

  const isTiwInlineTimerEnabled = useFeatureFlag('isTiwInlineTimerEnabled');
  const theme = useTheme();

  const clearToastContext = useCallback(
    (id: string) => {
      setToastContext({ id: id, message: 'toast.note.failure' }); //keeping old logic
    },
    [setToastContext]
  );
  const clearToastContext2 = useCallback(
    (id: string) => {
      setToastContextList((prev: NotesToastContext[]) => {
        return prev.filter((p) => p.id !== id);
      });
    },
    [setToastContextList]
  );

  if (isTiwInlineTimerEnabled) {
    return (
      <>
        {toastContextList
          .map((tc, i) => {
            return (
              <NoteToast
                key={tc.id}
                toastContext={tc}
                clearToastContext={clearToastContext2}
                pinned={pinned}
                dismiss={dismiss}
                offset={theme.spacing(2.5 + i * 8.75)}
              />
            );
          })
          .concat([
            <NoteToast
              key={toastContext.id}
              toastContext={toastContext}
              clearToastContext={clearToastContext}
              pinned={pinned}
              dismiss={dismiss}
            />
          ])}
      </>
    );
  }

  return (
    <NoteToast
      toastContext={toastContext}
      clearToastContext={clearToastContext}
      pinned={pinned}
      dismiss={dismiss}
    />
  );
};
